export default __webpack_public_path__ + "static/media/Secure login-bro.312d3353.svg";